import {IComponentOptions} from "angular";
import ApplicationController from "../../shared/application/application.controller";

export const ApplicationComponent: IComponentOptions = {
    bindings: {
        application: "<",
        applicationHistories: "<",
        assessments: "<",
        currentUser: "<",
        currentCourses: "<",
        teachingPeriods: "<",
        studentMode: "<"
    },
    controller: ApplicationController,
    template: require("./application.html"),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/student/application/application.component.ts